var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCmsandlms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 19C0 8.78273 8.28273 0.5 18.5 0.5V9.75C18.5 4.64137 22.6414 0.5 27.75 0.5C32.8586 0.5 37 4.64137 37 9.75C37 14.8586 32.8586 19 27.75 19H18.5V28.25C18.5 33.3586 14.3586 37.5 9.25 37.5C4.14137 37.5 0 33.3586 0 28.25V19Z",
    fill: "#044D76"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37 37.5C37 27.2827 28.7173 19 18.5 19C18.5 29.2173 26.7827 37.5 37 37.5Z",
    fill: "#044D76"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmsandlms);
export default __webpack_public_path__ + "static/media/cms and lms.721c42a1d653250681a740e4d825791e.svg";
export { ForwardRef as ReactComponent };